require('../module/popup');
require('../module/tab');
require('../module/skill');
require('../module/arms');
var roll = require('../module/roll');
roll();
